import { token } from '@atlaskit/tokens';
import React from 'react';

type ComponentProps = {
	className?: string;
};

export const LoginToConfluenceIcon = ({ className }: ComponentProps): React.JSX.Element => (
	<svg
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={className}
		width="148"
		height="160"
		viewBox="0 0 148 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_499_12980)">
			<rect
				width="147.652"
				height="160"
				transform="translate(0.174194)"
				fill={token('color.icon.inverse', 'white')}
				fillOpacity="0.01"
			/>
			<path
				d="M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z"
				fill={token('color.icon.accent.yellow', '#72594B')}
			/>
			<path
				d="M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z"
				fill={token('color.icon.accent.yellow', '#72594B')}
			/>
			<path
				d="M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z"
				fill={token('color.icon.accent.yellow', '#72594B')}
			/>
			<path
				d="M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z"
				fill={token('color.icon.accent.yellow', '#72594B')}
			/>
			<path
				opacity="0.7"
				d="M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z"
				fill="url(#paint0_linear_499_12980)"
			/>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M147.826 44.9982H121.774V46.1167H147.826V44.9982Z"
					fill="url(#paint1_linear_499_12980)"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M147.826 47.9763H121.774V49.0948H147.826V47.9763Z"
					fill="url(#paint2_linear_499_12980)"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M141.564 50.951H121.774V52.0696H141.564V50.951Z"
					fill="url(#paint3_linear_499_12980)"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M82.238 0H56.186V1.11852H82.238V0Z"
					fill="url(#paint4_linear_499_12980)"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M82.238 2.97815H56.186V4.09667H82.238V2.97815Z"
					fill="url(#paint5_linear_499_12980)"
				/>
			</g>
			<g opacity="0.6">
				<path
					opacity="0.6"
					d="M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z"
					fill="url(#paint6_linear_499_12980)"
				/>
			</g>
			<path
				opacity="0.7"
				d="M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z"
				fill="url(#paint7_linear_499_12980)"
			/>
			<path
				d="M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z"
				fill="url(#paint8_linear_499_12980)"
			/>
			<path
				d="M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z"
				fill={token('color.icon.inverse', 'white')}
			/>
			<path
				d="M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z"
				fill={token('color.background.accent.blue.subtlest', '#99C1FF')}
			/>
			<path
				d="M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z"
				fill={token('color.background.accent.blue.subtlest', '#CCE0FF')}
			/>
			<path
				d="M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z"
				fill={token('color.background.accent.blue.subtlest', '#99C1FF')}
			/>
			<path
				d="M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z"
				fill="url(#paint9_linear_499_12980)"
			/>
			<path
				d="M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z"
				fill={token('color.background.accent.yellow.subtlest', '#FFFAE5')}
			/>
			<path
				d="M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z"
				fill={token('color.background.accent.yellow.subtlest', '#FFE380')}
			/>
			<path
				d="M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z"
				fill={token('color.background.accent.yellow.subtlest', '#FFE380')}
			/>
			<path
				d="M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z"
				fill={token('color.background.accent.yellow.subtlest', '#FFE380')}
			/>
			<path
				opacity="0.7"
				d="M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z"
				fill="url(#paint10_linear_499_12980)"
			/>
			<path
				d="M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z"
				fill="url(#paint11_linear_499_12980)"
			/>
			<path
				d="M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z"
				fill={token('color.background.accent.yellow.subtle', '#FFC400')}
			/>
			<path
				d="M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z"
				fill={token('color.background.accent.yellow.subtle', '#FFC400')}
			/>
			<path
				d="M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z"
				fill={token('color.background.accent.yellow.subtle', '#FFC400')}
			/>
			<path
				d="M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				opacity="0.2"
				d="M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z"
				fill={token('color.background.accent.gray.subtle', '#6C798F')}
			/>
			<path
				d="M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z"
				fill={token('color.background.accent.yellow.subtle', '#FFC400')}
			/>
			<path
				d="M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z"
				fill={token('color.background.accent.gray.subtlest', '#DEEBFF')}
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z"
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419"
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858"
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M91.6116 84.6954V74.9203V65.1453V55.3737"
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				d="M75.3518 84.4312V75.1948V65.9584V56.722"
				stroke={token('color.background.accent.blue.subtlest', '#B2D4FF')}
				strokeWidth="3.1142"
				strokeMiterlimit="10"
			/>
			<path
				opacity="0.2"
				d="M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z"
				fill="url(#paint12_linear_499_12980)"
			/>
			<path
				d="M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z"
				fill="url(#paint13_linear_499_12980)"
			/>
			<path
				d="M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z"
				fill="url(#paint14_linear_499_12980)"
			/>
			<path
				d="M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z"
				fill="url(#paint15_linear_499_12980)"
			/>
			<path
				d="M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z"
				fill="url(#paint16_linear_499_12980)"
			/>
			<path
				opacity="0.2"
				d="M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z"
				fill={token('color.background.accent.gray.subtle', '#6C798F')}
			/>
			<path
				d="M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z"
				fill="url(#paint17_linear_499_12980)"
			/>
			<path
				d="M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z"
				fill="url(#paint18_linear_499_12980)"
			/>
			<path
				d="M49.5641 127.131L58.1314 128.784L49.5641 127.131Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M69.2103 130.922L67.4159 130.575L69.2103 130.922Z"
				fill={token('color.background.accent.gray.bolder', '#42526E')}
			/>
			<path
				d="M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z"
				fill={token('color.background.accent.gray.bolder', '#42526E')}
			/>
			<path
				d="M58.1315 128.784L63.0276 129.728L58.1315 128.784Z"
				fill={token('color.background.accent.gray.bolder', '#42526E')}
			/>
			<path
				d="M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z"
				fill={token('color.background.accent.gray.bolder', '#42526E')}
			/>
			<path
				d="M69.2103 130.922L83.9638 133.77L69.2103 130.922Z"
				fill={token('color.background.accent.gray.subtle', '#5E6C84')}
			/>
			<path
				d="M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z"
				fill={token('color.background.accent.gray.subtle', '#5E6C84')}
			/>
			<path
				d="M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z"
				fill={token('color.icon.accent.yellow', '#72594B')}
			/>
			<path
				d="M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z"
				fill="url(#paint19_linear_499_12980)"
			/>
			<path
				d="M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z"
				fill="url(#paint20_linear_499_12980)"
			/>
			<path
				d="M106.598 139.729L88.1222 136.103L106.598 139.729Z"
				fill={token('color.background.accent.gray.subtle', '#5E6C84')}
			/>
			<path
				d="M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z"
				fill={token('color.background.accent.gray.subtle', '#5E6C84')}
			/>
			<path
				d="M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z"
				fill={token('color.icon.inverse', '#FAFBFC')}
			/>
			<path
				d="M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z"
				fill="url(#paint21_linear_499_12980)"
			/>
			<path
				d="M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z"
				fill="url(#paint22_linear_499_12980)"
			/>
			<path
				opacity="0.2"
				d="M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z"
				fill="url(#paint23_linear_499_12980)"
			/>
			<path
				d="M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z"
				fill={token('color.background.accent.blue.bolder', '#2684FF')}
			/>
			<path
				d="M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z"
				fill={token('color.background.accent.blue.subtlest', '#B2D4FF')}
			/>
			<path
				d="M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z"
				fill={token('color.background.accent.teal.subtle', '#00C7E5')}
			/>
			<path
				d="M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z"
				fill={token('color.background.accent.blue.bolder', '#4C9AFF')}
			/>
			<path
				d="M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z"
				fill={token('color.icon.brand', '#0065FF')}
			/>
			<path
				d="M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z"
				fill={token('color.icon.brand', '#0065FF')}
			/>
			<path
				d="M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z"
				fill={token('color.icon.brand', '#0065FF')}
			/>
			<path
				d="M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z"
				fill={token('color.icon.brand', '#0065FF')}
			/>
			<path
				d="M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z"
				fill={token('color.icon', '#344563')}
			/>
			<path
				d="M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z"
				fill={token('color.background.accent.teal.subtle', '#00B8D9')}
			/>
			<path
				d="M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z"
				fill={token('color.icon', '#344563')}
			/>
			<path
				d="M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z"
				fill={token('color.background.accent.teal.subtle', '#00C7E5')}
			/>
			<path
				d="M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z"
				fill={token('color.background.accent.teal.subtle', '#79E2F2')}
			/>
			<path
				d="M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z"
				fill={token('color.background.accent.orange.subtler', '#CEA28B')}
			/>
			<path
				d="M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z"
				fill={token('color.background.accent.orange.subtler', '#CEA28B')}
			/>
			<path
				d="M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z"
				fill={token('color.background.accent.teal.subtle', '#79E2F2')}
			/>
			<path
				opacity="0.2"
				d="M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z"
				fill="url(#paint24_linear_499_12980)"
			/>
			<path
				d="M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z"
				fill="url(#paint25_linear_499_12980)"
			/>
			<path
				d="M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z"
				fill={token('color.background.accent.yellow.subtle', '#FFAB00')}
			/>
			<path
				d="M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z"
				fill="url(#paint26_linear_499_12980)"
			/>
			<path
				d="M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z"
				fill={token('color.background.accent.orange.subtler', '#CEA28B')}
			/>
			<path
				d="M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z"
				fill={token('color.background.accent.orange.subtler', '#E4B69D')}
			/>
			<path
				d="M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z"
				fill="url(#paint27_linear_499_12980)"
			/>
			<path
				d="M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z"
				fill={token('color.icon', '#253858')}
			/>
			<path
				d="M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z"
				fill="url(#paint28_linear_499_12980)"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_499_12980"
				x1="50.6701"
				y1="127.204"
				x2="144.895"
				y2="32.9795"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.2415"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFF')}
					stopOpacity="0.7585"
				/>
				<stop
					offset="0.4317"
					stopColor={token('color.background.accent.blue.bolder', '#59A1FF')}
					stopOpacity="0.5683"
				/>
				<stop
					offset="0.6043"
					stopColor={token('color.background.accent.blue.subtle', '#6AABFF')}
					stopOpacity="0.3957"
				/>
				<stop
					offset="0.7666"
					stopColor={token('color.background.accent.blue.subtle', '#81B8FF')}
					stopOpacity="0.2334"
				/>
				<stop
					offset="0.9202"
					stopColor={token('color.background.accent.blue.subtlest', '#9FC9FF')}
					stopOpacity="0.0798"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.blue.subtlest', '#B2D4FF')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint1_linear_499_12980"
				x1="121.776"
				y1="45.5575"
				x2="147.826"
				y2="45.5575"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtlest', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtlest', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint2_linear_499_12980"
				x1="121.776"
				y1="48.5346"
				x2="147.826"
				y2="48.5346"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint3_linear_499_12980"
				x1="121.776"
				y1="51.5113"
				x2="141.565"
				y2="51.5113"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint4_linear_499_12980"
				x1="56.1854"
				y1="0.55854"
				x2="82.2361"
				y2="0.55854"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint5_linear_499_12980"
				x1="56.1854"
				y1="3.53525"
				x2="82.2361"
				y2="3.53525"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint6_linear_499_12980"
				x1="56.1854"
				y1="6.51231"
				x2="75.9746"
				y2="6.51231"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint7_linear_499_12980"
				x1="54.7482"
				y1="124.969"
				x2="145.885"
				y2="33.833"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#2684FF')} />
				<stop
					offset="0.3613"
					stopColor={token('color.background.accent.blue.subtle', '#2986FF')}
					stopOpacity="0.6387"
				/>
				<stop
					offset="0.6457"
					stopColor={token('color.background.accent.blue.subtle', '#338CFF')}
					stopOpacity="0.3543"
				/>
				<stop
					offset="0.9031"
					stopColor={token('color.background.accent.blue.subtle', '#4495FF')}
					stopOpacity="0.0969"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.blue.subtle', '#4C9AFF')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint8_linear_499_12980"
				x1="132.434"
				y1="109.023"
				x2="129.764"
				y2="78.307"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.subtlest', '#99C1FF')} />
				<stop offset="0.7911" stopColor={token('color.background.accent.blue.subtle', '#66A3FF')} />
			</linearGradient>
			<linearGradient
				id="paint9_linear_499_12980"
				x1="23.785"
				y1="51.7314"
				x2="42.402"
				y2="33.1132"
				gradientUnits="userSpaceOnUse"
			>
				<stop
					offset="0.2089"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
				<stop offset="1" stopColor={token('color.background.accent.yellow.subtlest', '#FFE380')} />
			</linearGradient>
			<linearGradient
				id="paint10_linear_499_12980"
				x1="42.596"
				y1="129.08"
				x2="141.953"
				y2="29.7225"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.blue.bolder', '#4C9AFF')} />
				<stop
					offset="0.208"
					stopColor={token('color.background.accent.blue.bolder', '#4F9CFE')}
					stopOpacity="0.792"
				/>
				<stop
					offset="0.3719"
					stopColor={token('color.background.accent.blue.subtle', '#59A0FD')}
					stopOpacity="0.6281"
				/>
				<stop
					offset="0.5207"
					stopColor={token('color.background.accent.blue.subtle', '#6AA8FA')}
					stopOpacity="0.4793"
				/>
				<stop
					offset="0.6606"
					stopColor={token('color.background.accent.blue.subtler', '#81B4F6')}
					stopOpacity="0.3394"
				/>
				<stop
					offset="0.7942"
					stopColor={token('color.background.accent.blue.subtler', '#A0C2F0')}
					stopOpacity="0.2058"
				/>
				<stop
					offset="0.9214"
					stopColor={token('color.background.accent.blue.subtlest', '#C4D4EA')}
					stopOpacity="0.0786"
				/>
				<stop
					offset="1"
					stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')}
					stopOpacity="0"
				/>
			</linearGradient>
			<linearGradient
				id="paint11_linear_499_12980"
				x1="37.0626"
				y1="130.862"
				x2="125.647"
				y2="42.2776"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.gray.subtlest', '#DEEBFF')} />
				<stop
					offset="0.6383"
					stopColor={token('color.background.accent.gray.subtlest', '#EBF1FA')}
				/>
				<stop offset="1" stopColor={token('color.background.accent.gray.subtlest', '#F4F5F7')} />
			</linearGradient>
			<linearGradient
				id="paint12_linear_499_12980"
				x1="94.0388"
				y1="28.347"
				x2="117.556"
				y2="28.347"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.gray.subtle', '#6E7C93')} stopOpacity="0" />
				<stop offset="1" stopColor={token('color.background.accent.gray.subtle', '#6C798F')} />
			</linearGradient>
			<linearGradient
				id="paint13_linear_499_12980"
				x1="50.5705"
				y1="26.7136"
				x2="49.861"
				y2="13.9285"
				gradientUnits="userSpaceOnUse"
			>
				<stop
					offset="0.2629"
					stopColor={token('color.background.accent.orange.subtle', '#FF991F')}
				/>
				<stop
					offset="0.6568"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
				<stop
					offset="0.7051"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC607')}
				/>
				<stop
					offset="0.7745"
					stopColor={token('color.background.accent.yellow.subtle', '#FFCA1A')}
				/>
				<stop
					offset="0.8568"
					stopColor={token('color.background.accent.yellow.subtler', '#FFD239')}
				/>
				<stop
					offset="0.9483"
					stopColor={token('color.background.accent.yellow.subtler', '#FFDC64')}
				/>
				<stop offset="1" stopColor={token('color.background.accent.yellow.subtlest', '#FFE380')} />
			</linearGradient>
			<linearGradient
				id="paint14_linear_499_12980"
				x1="45.5246"
				y1="24.8807"
				x2="54.0025"
				y2="13.9733"
				gradientUnits="userSpaceOnUse"
			>
				<stop
					offset="0.321"
					stopColor={token('color.background.accent.orange.subtle', '#FF991F')}
				/>
				<stop
					offset="0.766"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
			</linearGradient>
			<linearGradient
				id="paint15_linear_499_12980"
				x1="101.929"
				y1="89.445"
				x2="103.151"
				y2="76.738"
				gradientUnits="userSpaceOnUse"
			>
				<stop
					offset="0.2629"
					stopColor={token('color.background.accent.orange.subtle', '#FF991F')}
				/>
				<stop
					offset="0.6568"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
				<stop
					offset="0.7051"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC607')}
				/>
				<stop
					offset="0.7745"
					stopColor={token('color.background.accent.yellow.subtle', '#FFCA1A')}
				/>
				<stop
					offset="0.8568"
					stopColor={token('color.background.accent.yellow.subtler', '#FFD239')}
				/>
				<stop
					offset="0.9483"
					stopColor={token('color.background.accent.yellow.subtler', '#FFDC64')}
				/>
				<stop offset="1" stopColor={token('color.background.accent.yellow.subtlest', '#FFE380')} />
			</linearGradient>
			<linearGradient
				id="paint16_linear_499_12980"
				x1="96.7524"
				y1="86.8327"
				x2="105.46"
				y2="77.236"
				gradientUnits="userSpaceOnUse"
			>
				<stop
					offset="0.321"
					stopColor={token('color.background.accent.orange.subtle', '#FF991F')}
				/>
				<stop
					offset="0.766"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
			</linearGradient>
			<linearGradient
				id="paint17_linear_499_12980"
				x1="46.7436"
				y1="124.678"
				x2="85.5786"
				y2="85.843"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.teal.subtle', '#00C7E5')} />
				<stop offset="0.1228" stopColor={token('color.background.accent.teal.subtle', '#2FD3EC')} />
				<stop offset="0.286" stopColor={token('color.background.accent.teal.subtle', '#67E2F4')} />
				<stop
					offset="0.4263"
					stopColor={token('color.background.accent.teal.subtler', '#90ECFA')}
				/>
				<stop
					offset="0.5367"
					stopColor={token('color.background.accent.teal.subtler', '#AAF3FE')}
				/>
				<stop
					offset="0.6033"
					stopColor={token('color.background.accent.teal.subtlest', '#B3F5FF')}
				/>
			</linearGradient>
			<linearGradient
				id="paint18_linear_499_12980"
				x1="55.645"
				y1="135.098"
				x2="94.1816"
				y2="96.5612"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.teal.subtle', '#00C7E5')} />
				<stop offset="0.1228" stopColor={token('color.background.accent.teal.subtle', '#2FD3EC')} />
				<stop offset="0.286" stopColor={token('color.background.accent.teal.subtle', '#67E2F4')} />
				<stop
					offset="0.4263"
					stopColor={token('color.background.accent.teal.subtler', '#90ECFA')}
				/>
				<stop
					offset="0.5367"
					stopColor={token('color.background.accent.teal.subtler', '#AAF3FE')}
				/>
				<stop
					offset="0.6033"
					stopColor={token('color.background.accent.teal.subtlest', '#B3F5FF')}
				/>
			</linearGradient>
			<linearGradient
				id="paint19_linear_499_12980"
				x1="82.9016"
				y1="129.529"
				x2="83.3365"
				y2="138.118"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.yellow.subtlest', '#FFE380')} />
				<stop offset="1" stopColor={token('color.background.accent.yellow.subtle', '#FFAB00')} />
			</linearGradient>
			<linearGradient
				id="paint20_linear_499_12980"
				x1="66.7271"
				y1="153.359"
				x2="112.794"
				y2="115.971"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.teal.subtle', '#00C7E5')} />
				<stop offset="0.1228" stopColor={token('color.background.accent.teal.subtle', '#2FD3EC')} />
				<stop offset="0.286" stopColor={token('color.background.accent.teal.subtle', '#67E2F4')} />
				<stop
					offset="0.4263"
					stopColor={token('color.background.accent.teal.subtler', '#90ECFA')}
				/>
				<stop
					offset="0.5367"
					stopColor={token('color.background.accent.teal.subtler', '#AAF3FE')}
				/>
				<stop
					offset="0.6033"
					stopColor={token('color.background.accent.teal.subtlest', '#B3F5FF')}
				/>
			</linearGradient>
			<linearGradient
				id="paint21_linear_499_12980"
				x1="64.8985"
				y1="150.541"
				x2="110.859"
				y2="113.239"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.teal.subtle', '#00C7E5')} />
				<stop offset="0.1228" stopColor={token('color.background.accent.teal.subtle', '#2FD3EC')} />
				<stop offset="0.286" stopColor={token('color.background.accent.teal.subtle', '#67E2F4')} />
				<stop
					offset="0.4263"
					stopColor={token('color.background.accent.teal.subtler', '#90ECFA')}
				/>
				<stop
					offset="0.5367"
					stopColor={token('color.background.accent.teal.subtler', '#AAF3FE')}
				/>
				<stop
					offset="0.6033"
					stopColor={token('color.background.accent.teal.subtlest', '#B3F5FF')}
				/>
			</linearGradient>
			<linearGradient
				id="paint22_linear_499_12980"
				x1="99.6982"
				y1="120.33"
				x2="103.749"
				y2="121.161"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.orange.subtle', '#FF991F')} />
				<stop
					offset="0.766"
					stopColor={token('color.background.accent.yellow.subtle', '#FFC400')}
				/>
			</linearGradient>
			<linearGradient
				id="paint23_linear_499_12980"
				x1="0.174194"
				y1="146.568"
				x2="56.0521"
				y2="146.568"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.icon', '#091E42')} stopOpacity="0" />
				<stop offset="1" stopColor={token('color.icon', '#091E42')} />
			</linearGradient>
			<linearGradient
				id="paint24_linear_499_12980"
				x1="58.1309"
				y1="158.125"
				x2="87.7433"
				y2="158.125"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.icon', '#091E42')} stopOpacity="0" />
				<stop offset="1" stopColor={token('color.icon', '#091E42')} />
			</linearGradient>
			<linearGradient
				id="paint25_linear_499_12980"
				x1="78.6253"
				y1="150.658"
				x2="68.697"
				y2="151.584"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.yellow.subtle', '#FFC400')} />
				<stop
					offset="0.452"
					stopColor={token('color.background.accent.orange.subtle', '#FF991F')}
				/>
			</linearGradient>
			<linearGradient
				id="paint26_linear_499_12980"
				x1="79.3893"
				y1="142.265"
				x2="75.8395"
				y2="140.601"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.yellow.subtle', '#FFC400')} />
				<stop
					offset="0.3539"
					stopColor={token('color.background.accent.yellow.subtle', '#FFB500')}
				/>
				<stop
					offset="0.7017"
					stopColor={token('color.background.accent.yellow.subtle', '#FFAB00')}
				/>
			</linearGradient>
			<linearGradient
				id="paint27_linear_499_12980"
				x1="76.9238"
				y1="139.183"
				x2="90.7241"
				y2="138.741"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor={token('color.background.accent.yellow.subtle', '#FFAB00')} />
				<stop
					offset="0.7262"
					stopColor={token('color.background.accent.yellow.subtlest', '#FFE380')}
				/>
			</linearGradient>
			<linearGradient
				id="paint28_linear_499_12980"
				x1="90.4515"
				y1="22.6491"
				x2="117.556"
				y2="22.6491"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0346" stopColor={token('color.icon.inverse', 'white')} />
				<stop
					offset="0.3965"
					stopColor={token('color.background.accent.gray.subtlest', '#F7F7F8')}
				/>
				<stop
					offset="0.9604"
					stopColor={token('color.background.accent.gray.subtlest', '#E1E3E6')}
				/>
				<stop offset="1" stopColor={token('color.background.accent.gray.subtlest', '#DFE1E5')} />
			</linearGradient>
			<clipPath id="clip0_499_12980">
				<rect
					width="147.652"
					height="160"
					fill={token('color.icon.inverse', 'white')}
					transform="translate(0.174194)"
				/>
			</clipPath>
		</defs>
	</svg>
);
